import { useSelector } from 'react-redux'

const useLoanType = loanTypeId => {
  const loanTypesById = useSelector(state => state.loanTypes.byId) || {}
  return loanTypesById[loanTypeId]
}

export default useLoanType
